// --------------------------------------------------------------------------
// toggleTile.js
// --------------------------------------------------------------------------
// Toggles a class to toggle tiles on hover
// --------------------------------------------------------------------------

EC.toggleTile = function () {

    'use strict';

    function init () {
        const canHover = EC.trueHover.getTrueHover();
        if(canHover){
            const $tile = $('.js-toggle-tile');
            $tile.on('mouseover', showDetails);
            $tile.on('mouseout', hideDetails);
        }
        $('.js-toggle-tile__trigger').on('click', toggleDetails);
    }

    function showDetails () {
        $(this).find('.e-toggle-trigger').addClass('e-toggle-trigger--is-open').siblings('.js-toggle-tile__copy').stop().slideDown();
    }

    function hideDetails () {
        $(this).find('.e-toggle-trigger').removeClass('e-toggle-trigger--is-open').siblings('.js-toggle-tile__copy').stop().slideUp();
    }

    function toggleDetails () {
        $(this).toggleClass('e-toggle-trigger--is-open').siblings('.js-toggle-tile__copy').slideToggle();
    }

    return {
        init: init
    };

}();